import { render, staticRenderFns } from "./channelMpago.vue?vue&type=template&id=6b18f442&"
import script from "./channelMpago.vue?vue&type=script&lang=js&"
export * from "./channelMpago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports